import { styled } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const WarningIcon = styled(ReportProblemIcon)`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 0.7em;
  height: 0.7em;

  color: red;
`;
export default WarningIcon;
